import { useCurrentCase, useParams } from "duck";

export const useDentalChart = () => {
  const { toothNumber } = useParams();

  const dentalChart = useCurrentCase(
    ({ data }) =>
      data.client.patient.dentalChartings?.find(
        chart => chart.tooth === +toothNumber
      ) || null
  );

  return dentalChart;
};
